<template>
  <v-sheet class="transparent-background-color">
    <div
      class="caption grey--text input-chip-group-label"
      :class="$vuetify.theme.dark?'text--lighten-1':'text--darken-1'"
    >{{ $t('Order.status.title') }}</div>
    <v-chip-group v-model="model" column multiple>
      <v-chip
        v-for="stat in $consts.order.status"
        small
        label
        filter
        class="me-1"
        :color="stat.color"
        :text-color="stat.textColor"
        :key="stat.value"
        :value="stat.value"
      >{{ stat.text }}</v-chip>
    </v-chip-group>
  </v-sheet>
</template>

<script>
export default {
  name: "SearcherOrderStatus",

  props: ["value"],

  data: () => ({
    model: [1, 2, 3, 4, 5, 6],
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.model = this.value;
      },
    },
    model: {
      handler() {
        this.$emit("input", this.model);
      },
    },
  },
};
</script>
